import React from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { AppTrace } from 'services/azure-app-insights/appTrace';

// components
import { Card, Link, Text } from '@ui';
import { DescriptionWithLinks } from 'components/DesignSystem';

interface IProps {
  messageVersion: string;
  onDismissed: () => void;
}

const AnnouncementCard = ({ messageVersion, onDismissed }: IProps) => {
  const { t } = useTranslation('common');

  const onDismissClick = () => {
    AppTrace.announcementDismissed(messageVersion);
    onDismissed();
  };

  return (
    <StyledCard variant="borderless">
      <StyledCardContent>
        <Text variant="h4" weight="semi-bold">
          {t(`announcement_modal.${messageVersion}.title`)}
        </Text>

        <StyledDescriptionWithLinks
          description={t(`announcement_modal.${messageVersion}.body`)}
        />

        <DismissButton onClick={onDismissClick}>
          {t(`announcement_modal.${messageVersion}.ok_button`)}
        </DismissButton>
      </StyledCardContent>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  border-radius: 7px;

  .ant-card-body {
    padding: 30px;
  }
`;

const StyledCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DismissButton = styled(Link)`
  cursor: pointer;
  text-align: center;
  color: ${({ theme }) => theme.colorLightD1} !important;
  transition: ${({ theme }) => theme.defaultTransition};

  &:hover {
    color: ${({ theme }) => theme.colorWhite} !important;
  }
`;

const StyledDescriptionWithLinks = styled(DescriptionWithLinks)`
  white-space: pre-line;
`;

export default AnnouncementCard;
